import { ReactNode } from "react";

interface HeadProps {
  title: string;
  children?: ReactNode;
}

export default function HeadTitleKeyword({ title, children }: HeadProps) {
  // React hoists `title` and `meta` into `document.head` on its own; this
  // needs no wrapper.
  return (
    <>
      <title>
        {title ?? "Webshare Buy Proxy Servers | Fast &amp; Affordable "}
      </title>
      <meta
        name="keywords"
        content="proxy, shared proxy, dedicated proxy, proxy server, proxy service, free proxy, proxy list"
      />
      {children}
    </>
  );
}
